// src/utils/cookies.ts

/**
 * Get the value of a cookie by name from document.cookie.
 * @param cookieName The name of the cookie to retrieve.
 * @returns The cookie value, or an empty string if not found.
 */
export function getCookieByName(cookieName: string): string {
    const match = typeof document !== 'undefined' && document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
    return match ? match.pop() || '' : '';
}
